module.exports = __webpack_public_path__ + "static/media/kayfik_loader.e361f9e9.gif";